import React from "react";
import useWindowTools from "../../../react-hooks/useWindowTools";

export const Title1 = (props) => {
  const {children, className = "", style} = props;
  const {isMobile} = useWindowTools();

  return (
    <h1
      className={`
        font-size-h1${isMobile ? "-mobile" : ""}
        ${className}
      `}
      style={{...style}}
    >
      {children}
    </h1>
  );
};

export const Title2 = (props) => {
  const {children, className = "", style} = props;
  const {isMobile} = useWindowTools();

  return (
    <h2
      className={`
        font-size-h2${isMobile ? "-mobile" : ""}
        ${className}
      `}
      style={{...style}}
    >
      {children}
    </h2>
  );
};

export const Title3 = (props) => {
  const {children, className = "", style} = props;

  return <h2 className={`font-size-h3 ${className}`} style={{...style}}>
    {children}
  </h2>;
};
